import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { isBrowser } from 'react-device-detect';

import { I18n } from '../../utils/I18n';
import Setting from '../../Settings';
import AlertDialog from '../../utils/AlertDialog';


export default class CreateUser extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    AccountStr:"",
    PasswordStr:"",
    ConfirmPsdStr:"",
    EmailStr:"",
    NameStr:"",
    PhoneStr:"",
    UserRole:"2",

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    console.log("create user page init.");
  }

  handleInputChange=(event)=>{
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({[name]: value});

  }


  render() {
    let columnClass = isBrowser ? "d-flex flex-row w-50" : "d-flex flex-row";

    return (
      <div className="p-4">
        <h4 style={{marginBottom: "30px"}}><b><u><FormattedMessage id="mainPage.users.create" /></u></b></h4>
        <Form style={{width: isBrowser ? "80%":"100%"}}
        >
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.account.title" /></span>
            <Form.Control type="text" size="sm" 
              placeholder={I18n.t("createUser.account.holder", {min: Setting.limit.account_length_min, max: Setting.limit.account_length_max})}
              name="AccountStr"
              value={this.state.AccountStr} onChange={this.handleInputChange}
              />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.password.title" /></span>
            <Form.Control type="password" size="sm" 
            name="PasswordStr"
            value={this.state.PasswordStr} onChange={this.handleInputChange}
              placeholder={I18n.t("createUser.password.holder", {min: Setting.limit.password_length_min, max: Setting.limit.password_length_max})} />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.password.title2" /></span>
            <Form.Control type="password" size="sm" 
            name="ConfirmPsdStr"
            value={this.state.ConfirmPsdStr} onChange={this.handleInputChange}
              placeholder={I18n.t("createUser.password.holder", {min: Setting.limit.password_length_min, max: Setting.limit.password_length_max})} />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.email.title" /></span>
            <Form.Control type="email" size="sm" placeholder={I18n.t("createUser.email.holder")} 
            name="EmailStr" value={this.state.EmailStr} onChange={this.handleInputChange}
            />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.username.title" /></span>
            <Form.Control type="text" size="sm" placeholder={I18n.t("createUser.username.holder")} 
            name="NameStr"  value={this.state.NameStr} onChange={this.handleInputChange}
            />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.phone.title" /></span>
            <Form.Control type="tel" size="sm" placeholder={I18n.t("createUser.phone.holder")} 
            name="PhoneStr"  value={this.state.PhoneStr} onChange={this.handleInputChange}
            />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="createUser.role.title" /></span>
            <div className="d-flex flex-row w-100 align-items-center">
              <Form.Control size="sm" as="select" id="permissionSelect" name="UserRole" onChange={this.handleInputChange}>
                <option value="2">{I18n.t("userListPage.permis.sysman")}</option>
                <option value="1">{I18n.t("userListPage.permis.editor")}</option>
                <option value="0">{I18n.t("userListPage.permis.subscrib")}</option>
              </Form.Control>

            </div>
          </div>

          <Button variant="outline-dark" className="h-100" size="sm"
         onClick={() =>{
          var url = '/api/account/create';
          var data = {loginId:this.state.AccountStr,password:this.state.PasswordStr,name:this.state.NameStr,phone:this.state.PhoneStr,email:this.state.EmailStr,UserRole:this.state.UserRole};
          
          //帳號驗證
          const Accountregex =/^[A-Za-z0-9]{6,16}$/;
          
          if (!Accountregex.test(this.state.AccountStr)){
            AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyAccountstrError"));
            console.log("新增使用者:帳號檢查錯誤");
            return;
          };
          
          //密碼驗證
          const Passwordregex =/^[A-Za-z0-9]{6,16}$/;
          
          if (!Passwordregex.test(this.state.PasswordStr)){
            AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyPasswordstrEmpty"));
            console.log("新增使用者:密碼檢查錯誤");
            return;
          };
          if (this.state.NameStr===""){
            AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyNamestrEmpty"));
            console.log("新增使用者:姓名不能為空");
            return;
          };
          const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          if (!regex.test(this.state.EmailStr)){
            AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyEmailstrEmpty"));
            console.log("新增使用者:Email檢查異常");
            return;
          };

          if (this.state.PasswordStr !== this.state.ConfirmPsdStr){
            AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyConfirmPsd"));
            console.log("新增使用者:確認密碼與密碼不一致");
            return;
          }
          const reg0 = /^\d{5,12}$/;
          if (!reg0.test(this.state.PhoneStr)){
            AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.PhoneNumCheck"));
            console.log("新增使用者:電話檢查異常");
            return;
          }

          
          fetch(url, {
            method: 'POST', // or 'PUT'
            credentials: 'include',
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: new Headers({
              'Content-Type': 'application/json'
            })
          }).then(res => res.json())
          .catch(error => {console.error('Error:', error);
          AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyFail"));
        })
          .then(response => {console.log('Create User Success:', response);
          AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplySuccess"));
        });

          
          
        }}
            style={{ backgroundImage: "url('/images/button_bg2.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}>
            <FormattedMessage id="mainPage.users.create" /></Button>
        </Form>
      </div>
    );
  }
}